import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import Fadeup from "../fadeup/Fadeup";

const base_url = process.env.REACT_APP_BASE_URL;

const ProductBanner = () => {
  const [auctionData, setAuctionData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [savingId, setSavingId] = useState(null);
  const [savedAuctions, setSavedAuctions] = useState(new Set());
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);

    // Load saved auctions from localStorage
    if (token) {
      const saved = localStorage.getItem("savedAuctions");
      if (saved) {
        try {
          const savedIds = JSON.parse(saved);
          setSavedAuctions(new Set(savedIds));
        } catch (err) {
          console.error("Error parsing saved auctions:", err);
        }
      }
    }

    const fetchAuctions = async () => {
      try {
        const response = await fetch(`${base_url}/api/auction/listAuction?status=approved`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const result = await response.json();
        if (!response.ok) throw new Error(result.message || "Failed to fetch auctions");

        setAuctionData(result.data || []);
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    fetchAuctions();

    // Listen for auction removal events
    const handleAuctionRemoved = (event) => {
      const { auctionId } = event.detail;
      setSavedAuctions(prev => {
        const newSet = new Set(prev);
        newSet.delete(auctionId);
        return newSet;
      });
    };

    // Add event listener
    window.addEventListener('auctionRemoved', handleAuctionRemoved);

    // Cleanup
    return () => {
      window.removeEventListener('auctionRemoved', handleAuctionRemoved);
    };
  }, []);

  const handleSaveAuction = async (e, auctionId) => {
    e.preventDefault(); // Prevent the link navigation
    e.stopPropagation(); // Prevent event bubbling
    
    const token = localStorage.getItem("token");
    setSavingId(auctionId);

    try {
      const response = await fetch(`${base_url}/api/auction/saveAuction`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          auction_id: auctionId,
          status: 1,
        }),
      });

      const result = await response.json();

      if (response.ok) { // Fixed: Check if response is OK for success
        toast.success('Auction saved successfully');
        const newSavedAuctions = new Set([...savedAuctions, auctionId]);
        setSavedAuctions(newSavedAuctions);
        
        // Persist to localStorage
        localStorage.setItem("savedAuctions", JSON.stringify([...newSavedAuctions]));
      } else {
        toast.error(result.message || 'Failed to save auction');
      }

    } catch (err) {
      toast.error(err.message || "Something went wrong while saving auction");
    } finally {
      setSavingId(null);
    }
  };

  if (loading) return <p>Loading auctions...</p>;
  if (error) return <p className="text-danger">{error}</p>;

  return (
    <section className="sec_pd">
       <Fadeup delay={0.3}>
        <h3 className="text-start mt-5 mb-3 mx-3 pb-2 text-black fs_40">
        Live Auction of Rare Masterpieces <br />& Timeless Treasures
      </h3>
        </Fadeup>
     <Fadeup delay={0.2}>
     <p className="text-start mb-4 mx-3 border-bottom pb-2 text-muted">
     Discover iconic works, exclusive collectibles, and once-in-a-lifetime finds at our premier live auction.
      </p>
     </Fadeup>
      <div className="my-5">
        <div className="latest-news-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' }}>
          {auctionData.map((auction) => (
            <div className="news-card-wrapper   mb-5" key={auction.id} style={{ display: 'flex', borderRadius:"20px" }}>
              <Link to={`/auctiondetails/${auction.id}`} style={{ display: 'flex', width: '100%', textDecoration: 'none' }}>
                <div className="news-card   cursor-pointer" style={{ display: 'flex', flexDirection: 'column', width: '100%',borderRadius:"20px" }}>
                  <div className="news-card-image-wrapper  " >
                    <img
                      className="news-card-image"
                      src={auction.details?.image}
                      alt={auction.title}
                    />
                  </div>
                  <div className="news-card-body card_floral floral-border" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                    <h5 className="news-card-title text-black fw_600">
                      {auction.title}
                    </h5>
                    <p className="news-card-text text-black" style={{ flex: 1 }}>
                      {auction.details?.description?.slice(0, 100)}...
                    </p>
                    {isLoggedIn && (
                      <div className="text-end mt-2">
                       <button
                      className={`btn btn-golden-glass ${savedAuctions.has(auction.id) ? 'disabled' : ''}`}
                      onClick={(e) => handleSaveAuction(e, auction.id)}
                      disabled={savingId === auction.id || savedAuctions.has(auction.id)}
                    >
                      {savingId === auction.id
                        ? "Saving..."
                        : savedAuctions.has(auction.id)
                        ? "Saved"
                        : "Save Auction"}
                    </button>

                      </div>
                    )}
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductBanner;